import {
  Table,
  TableBodyInfiniteScroll,
  TableHeader
} from '@library/components/table';
import { NoResults } from '@library/components/NoResults';
import type { TransformedUnsettlementsActionsResponse } from '@library/types/unsettlements';
import { UNSETTLEMENTS_TABLE_HEADER } from '@bo-constants/unsettlements';
import { UnsettlementsRow } from '@bo-components/unsettlements/unsettlementsList/UnsettlementsRow';
import { useMemo } from 'react';

export interface UnsettlementsTableProps {
  currentPage: number;
  handleCurrentPageChange: () => void;
  totalPages: number;
  unsettlementsData: Array<TransformedUnsettlementsActionsResponse>;
}

export const UnsettlementsTable = ({
  currentPage,
  handleCurrentPageChange,
  totalPages,
  unsettlementsData
}: UnsettlementsTableProps) => {
  const infiniteScrollProps = useMemo(
    () => ({
      dataLength: unsettlementsData?.length ?? 0,
      hasMore: totalPages > currentPage,
      loader: <p>Loading...</p>,
      next: handleCurrentPageChange
    }),
    [
      unsettlementsData?.length,
      currentPage,
      handleCurrentPageChange,
      totalPages
    ]
  );

  if (!unsettlementsData?.length) {
    return (
      <NoResults
        className="m-0"
        dataTestId="no-unsettlements"
        label="Unsettlements not found"
      />
    );
  }
  return (
    <Table
      className="border-soFresh-130 h-full overflow-auto rounded-lg border"
      dataTestId="unsettlements-list"
    >
      <TableHeader
        headers={UNSETTLEMENTS_TABLE_HEADER}
        className="bg-soFresh-120 text-soClean-160 px-4"
      />
      <TableBodyInfiniteScroll
        bodyHeight="[calc(100vh-11rem)]"
        bodyMaxHeight="max-h-[calc(100vh-11rem)]"
        infiniteScrollProps={infiniteScrollProps}
        scrollId="UnsettlementsTableBody"
      >
        {unsettlementsData.map((unsettlement) => (
          <UnsettlementsRow
            key={unsettlement.actionId}
            rowData={unsettlement}
          />
        ))}
      </TableBodyInfiniteScroll>
    </Table>
  );
};
